import { useNavigate, useParams, useSearchParams } from "react-router";

import { getTodaysDate } from "@/lib/dayjs/get-todays-date";

import type { ManagementReservationSearchTypeForQueryParams } from "@/routes/_constants/query-params/management";
import { isManagementReservationSearchType, RESERVATION } from "@/routes/_constants/query-params/management";
import { PATHS } from "@/routes/paths";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";

import type { ParamParseKey } from "react-router";

type Success = {
	canRender: true;
	hotelID: string;
	reservationSearchType: ManagementReservationSearchTypeForQueryParams;
	startDate: string;
	endDate: string;
	reservationID: string;
};

type Failure = {
	canRender: false;
};

type ReturnType = Success | Failure;

export const useConfirmParams = (): ReturnType => {
	const { hotelID } = useParams<ParamParseKey<typeof PATHS.HOTEL.MANAGEMENT.RESERVATION.TOP>>();
	const [searchParams] = useSearchParams();

	const rawReservationSearchType = searchParams.get(RESERVATION.SEARCH_TYPE.KEY);

	const reservationSearchType = isManagementReservationSearchType(rawReservationSearchType)
		? rawReservationSearchType
		: RESERVATION.SEARCH_TYPE.VALUE.STAY_DATE;
	const startDate = searchParams.get(RESERVATION.DATE_RANGE.START_DATE.KEY) || getTodaysDate();
	const endDate = searchParams.get(RESERVATION.DATE_RANGE.END_DATE.KEY) || getTodaysDate();
	const reservationID = searchParams.get(RESERVATION.RESERVATION_ID.KEY) || "";

	const navigate = useNavigate();

	let canRender = true;

	/**
	 * @todo ブランク時の振る舞いを設計
	 */
	if (!hotelID) {
		canRender = false;
		notifyUserEventInfo({
			title: "無効なURLです",
			description: "",
		});
		navigate(PATHS.TOP);

		return {
			canRender,
		};
	}

	return {
		canRender,
		hotelID,
		reservationSearchType,
		startDate,
		endDate,
		reservationID,
	};
};
